class ProductRecommender {
  constructor(options = {}) {
    const currencySymbol = typeof currency !== 'undefined' ? currency.symbol : '$';

    this.defaults = {
      containerSelector: '.js-go-cart-recommendations',
      itemSelector: '.js-go-cart-recommendation-item',
      productUrl: '/products/',
      limit: 10,
      recommendationType: 'best-selling',
      moneyFormat: currencySymbol + "{{amount}}",
      excludeTypes: ['Older_version']
    };

    this.settings = { ...this.defaults, ...options };
    this.itemClickHandler = this.handleItemClick.bind(this);
    this.init();
  }

  init() {
    this.container = document.querySelector(this.settings.containerSelector);
    if (!this.container) return;

    document.addEventListener('goCart:updated', (e) => {
      this.updateRecommendations(e.detail.cart);
    });

    this.updateRecommendations();
  }

  async updateRecommendations(cart = null) {
    try {
      if (!cart) cart = await this.fetchCart();
      const recommendations = await this.fetchRecommendations(cart);
      const cartProductIds = cart.items.map(item => item.product_id.toString());
      const filtered = this.filterRecommendations(recommendations, cartProductIds);
      this.renderRecommendations(filtered);
    } catch (error) {
      console.error('推荐产品加载失败:', error);
      this.container.style.display = 'none';
    }
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    return await response.json();
  }

  async fetchRecommendations(cart) {
    try {
      const response = await fetch('/collections/recommend-product/products.json?limit=10');
      if (!response.ok) throw new Error('Failed to fetch products');
      const data = await response.json();
      return data.products || [];
    } catch (error) {
      console.error('获取推荐产品失败:', error);
      return [];
    }
  }

  filterRecommendations(products, cartProductIds) {
    if (!products || !Array.isArray(products)) return [];

    return products
      .filter(product =>
        product.id &&
        !cartProductIds.includes(product.id.toString()) &&
        !this.settings.excludeTypes.includes(product.product_type)
      )
      .slice(0, this.settings.limit);
  }

  renderRecommendations(products) {
    if (products.length === 0) {
      this.container.style.display = 'none';
      return;
    }

    this.container.style.display = 'inline-flex';
    this.container.innerHTML = `    
        ${products.map(product => this.renderProduct(product)).join('')}       
    `;

    document.querySelectorAll(this.settings.itemSelector).forEach(item => {
      item.removeEventListener('click', this.itemClickHandler);
      item.addEventListener('click', this.itemClickHandler);
    });
  }

 renderProduct(product) {
  const variant = product.variants[0];
  const imageUrl = product.images?.[0]?.src || '';
  const priceCents = Math.round(parseFloat(variant.price || "0") * 100);
  const compareAtCents = variant.compare_at_price
    ? Math.round(parseFloat(variant.compare_at_price) * 100)
    : null;

  const formatMoney = window.formatMoney || ((cents, format) => {
    const amount = (cents / 100).toFixed(2);
    return format.replace('{{amount}}', amount);
  });

  const price = formatMoney(priceCents, this.settings.moneyFormat);
  const compareAtPrice = compareAtCents
    ? `<span class="compare-price">${formatMoney(compareAtCents, this.settings.moneyFormat)}</span>`
    : '';

  return `
    <div class="swiper-slide recommendation-item">
      <a href="${this.settings.productUrl}${product.handle}" class="recommendation-link">
        <div class="recommendation-image">
          <img src="${imageUrl}" alt="${product.title}" style="width: 100%; height: auto;" />
        </div>      
      </a>
     <button class="btn js-go-cart-recommendation-item" data-id="${variant.id}">
  <span class="btn-text">ADD TO CART</span>
 <span class="btn-spinner" aria-hidden="true" style="display: none;">
  <svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <circle class="path" fill="none" stroke="#ffffff" stroke-width="6" cx="33" cy="33" r="30" />
  </svg>
</span>
</button>
       <div class="recom-product-title">${product.title}</div>
        <div class="recommendation-price">
          ${price}
          ${compareAtPrice}
        </div>
    </div>
  `;
}


  handleItemClick(e) {
    e.preventDefault();
    const variantId = e.currentTarget.dataset.id;
    if (variantId) {
      this.addToCart(variantId);
    }
  }

 async addToCart(variantId) {
  const button = document.querySelector(`.js-go-cart-recommendation-item[data-id="${variantId}"]`);
  if (!button) return;

  const spinner = button.querySelector('.btn-spinner');
  const text = button.querySelector('.btn-text');

  button.disabled = true;
  if (text) text.style.display = 'none';
  if (spinner) spinner.style.display = 'flex';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!response.ok) throw new Error('failed add to cart');

    if (window.goCart?.fetchCart) {
      const updatedCart = await goCart.fetchCart();
      document.dispatchEvent(new CustomEvent('goCart:updated', {
        detail: { cart: updatedCart }
      }));
    }

    //this.showSuccessMessage();
    $('.footer-cart-drawer').css('display', 'block');
    $('.cart-title').text('Your Cart');

  } catch (error) {
    console.error('添加产品失败:', error);
  } finally {
    button.disabled = false;
    if (text) text.style.display = 'inline-block';
    if (spinner) spinner.style.display = 'none';
  }
}

  // showSuccessMessage() {
  //  // alert('Product added to cart!');
  // }
}

// 初始化
document.addEventListener('DOMContentLoaded', () => {
  new ProductRecommender({
    containerSelector: '.cart-recommendations',
    recommendationType: 'best-selling',
    productUrl: '/products/' // 根据你 Shopify 站点结构修改
  });
});